<template>
  <div class="digital-custome-container">
    <div class="pc d-none d-lg-block">
      <div class="container" data-aos="fade-left" :data-aos-duration="1 * 1000">
        <div class="left">
          <img src="https://zealcomm-site-assets.zealcomm.cn/new-product/digital-customer.png" alt="" />
        </div>
        <div class="right">
          <p class="intelligent-double-recording">数字人客服</p>
          <p class="subtitle">
            提供AI虚拟人能力，7*24小时在线，提供灵活可配的全自动<br />业务流程编辑功能，切换代替人工客服完成业务流程，业务<br />服务效率提升，用户满意度提升。
          </p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
      </div>
    </div>
    <div class="d-lg-none mobile">
      <div class="container" data-aos="fade-left" :data-aos-duration="1 * 1000">
        <div class="top">
          <p class="title">数字人客服</p>
          <p class="subtitle">
            提供AI虚拟人能力，7*24小时在线，提供灵活可配的全自动业务流程编辑功能，切换代替人工客服完成业务流程，业务服务效率提升，用户满意度提升。
          </p>
          <p class="btn-text" @click="open">了解更多 →</p>
        </div>
        <div class="bottom">
          <img src="~assets/img/solution/digitalCustomer-mobile.png" alt="" />
        </div>
      </div>
    </div>
    <Form v-model="show" />
  </div>
</template>

<script>
  import Form from "@/components/Form/index.vue";
  export default {
    data() {
      return {
        show: false,
      };
    },
    components: {
      Form,
    },
    methods: {
      open() {
        if (typeof this.customBtnClick === "function") {
          this.customBtnClick.call();
        } else {
          this.show = true;
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .pc {
    .container {
      display: flex;
      justify-content: space-between;
      padding: 58px 0 86px;
      .left {
        flex: 1;
        img {
          width: 500px;
          height: 336px;
        }
      }

      .right {
        flex: 1;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #363636;
        margin: 48px 0 0 131px;
        .intelligent-double-recording {
          font-size: 30px;
          font-weight: 500;
        }
        .subtitle {
          text-align: left;
          margin-top: 32px;
          font-size: 18px;
          font-weight: 400;
        }
        .btn-text {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #08c6ad;
          cursor: pointer;
          margin-top: 45px;
        }
      }
    }
  }
  .mobile {
    .container {
      padding: 40px 0 40px;
      .top {
        font-family: PingFangSC-Medium, PingFang SC;
        color: #363636;
        margin-left: 20px;
        .title {
          font-size: 18px;
          font-weight: 500;
        }
        .subtitle {
          font-size: 13px;
          font-weight: 400;
          padding: 18px 40px 0 0;
        }
        .btn-text {
          width: 102px;
          height: 24px;
          border-radius: 3px;
          border: 1px solid #0ab49e;
          margin-top: 16px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #08c6ad;
          text-align: center;
        }
      }
      .bottom {
        margin: 30px 20px 0 19px;
        img {
          width: 336px;
          height: 246px;
        }
      }
    }
  }
</style>
